import React, { useState } from "react";
import Card from "../../../../../components/Card";
import cn from "classnames";
import styles from "./MobileApplicationIndex.module.sass";
import Icon from "../../../../../components/Icon";
import Panel from "./Panel/Index";
import Radio from "../../../../../components/Radio";
import { POST_PICKLIST_BATCH } from "../../../../../API/Store";
import useDarkMode from "use-dark-mode";
import CustomToast from "../../../../../components/CustomToast";
import { useNavigate } from "react-router";

const MobileApplicationIndex = () => {
  const [selectedOption, setSelectedOption] = useState("users");
  const [isLoading, setIsLoading] = useState(false);
  const darkMode = useDarkMode(false);
  const [batchSize, setBatchSize] = useState(0);
  const showToast = CustomToast();
  const navigate = useNavigate();
  const increment = () => setBatchSize((prev) => prev + 1);

  const decrement = () => {
    setBatchSize((prev) => {
      if (prev === 0) return 0;
      return prev - 1;
    });
  };

  const handleRadioChange = (option) => {
    setSelectedOption(option);
  };

  const mapOptionToAPIValue = (option) => {
    switch (option) {
      case "users":
        return "BOTH";
      case "products":
        return "PRODUCT";
      case "orders":
        return "ORDER";
      default:
        return "BOTH";
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const payload = {
        batch_type: mapOptionToAPIValue(selectedOption),
        batch_size: batchSize,
      };
      await POST_PICKLIST_BATCH(payload);
      showToast("Settings saved successfully", "success");
    } catch (error) {
      showToast("Failed to save settings", "error");
      console.error("Failed to save settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Card
        className={styles.card}
        title="Mobile Application"
        classTitle="title-red"
        head={
          <button
            className={cn("button-stroke")}
            onClick={() => navigate("/settingsDashboard/accessControl")}
          >
            <Icon name="arrow-left" size="24" />
            <span>Back</span>
          </button>
        }
      >
        <div className="p-4 space-y-6">
          <div className="space-y-3">
            <Radio
              content="Users can customize this choice"
              name="appOption"
              value={selectedOption === "users"}
              onChange={() => handleRadioChange("users")}
              reverse
            />
            <Radio
              content="Products"
              name="appOption"
              value={selectedOption === "products"}
              onChange={() => handleRadioChange("products")}
              reverse
            />
            <Radio
              content="Orders"
              name="appOption"
              value={selectedOption === "orders"}
              onChange={() => handleRadioChange("orders")}
              reverse
            />
          </div>
        </div>
        <div className={cn("mt-[2%]")}>
          <label
            className={cn(
              "block mb-2",
              darkMode.value ? "text-white" : "text-gray-700"
            )}
          >
            Batch Size
          </label>
          <div
            className={cn(
              "inline-flex items-center px-3 py-2 rounded-lg",
              darkMode.value ? "bg-gray-700" : "bg-[#F4F4F4]",
              "shadow-sm"
            )}
          >
            <span
              className={cn(
                "mr-10",
                darkMode.value ? "text-white" : "text-gray-900"
              )}
            >
              {batchSize}
            </span>
            <div className="inline-flex rounded-md shadow-sm" role="group">
              <button
                onClick={decrement}
                disabled={batchSize === 0}
                className={`px-2 py-2 text-sm font-medium ${
                  darkMode.value
                    ? "bg-black text-[black] hover:border border-[black]-200"
                    : "bg-[#E8E8E8] text-gray-900"
                } bg-white rounded-l-lg hover:bg-gray-200 focus:z-10 focus:text-blue-700 ${
                  batchSize === 0 ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                <Icon name="minus" size="16" fill="#6F767E" />
              </button>
              <button
                className={`px-2 py-2 text-sm font-medium ${
                  darkMode.value
                    ? "bg-black text-[black] hover:border border-[black]-100"
                    : "bg-[#E8E8E8] text-gray-900"
                } rounded-r-lg hover:bg-gray-200 focus:z-10 focus:text-blue-700`}
                onClick={increment}
              >
                <Icon name="add" size="16" fill="#6F767E" />
              </button>
            </div>
          </div>
        </div>
      </Card>
      <div className="fixed bottom-7 left-30 right-5">
        <Panel onSubmit={handleSubmit} isLoading={isLoading} />
      </div>
    </>
  );
};

export default MobileApplicationIndex;
